import { ViewPetProfile } from "../../features/account_settings/components/pets/ViewPetProfile";

const ViewPetPage = () => {
  return <ViewPetProfile />
};
export default ViewPetPage;